import { faBan, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTheme } from "@hooks/useTheme";

const StatusBadge = ({ isAllowed, t, "data-testid": dataTestId = "status-badge" }) => {
  const { colors } = useTheme();
  const config = isAllowed
    ? {
      bg: colors.bgStatusAllowed,
      color: colors.textStatusAllowed,
      icon: faCheckCircle,
      label: t("project.imported-components.allow"),
    }
    : {
      bg: colors.bgStatusBlocked,
      color: colors.textStatusBlocked,
      icon: faBan,
      label: t("project.imported-components.block"),
    };

  return (
    <div
      className={`flex justify-center items-center h-6 w-28 ${config.bg} rounded-3xl`}
      data-testid={dataTestId}
    >
      <span data-testid={`${dataTestId}-icon`}>
        <FontAwesomeIcon icon={config.icon} className={`w-4 h-4 ${config.color}`} />
      </span>
      <div
        className={`truncate text-[0.8125rem] font-semibold ${config.color} ml-1`}
        title={config.label}
        data-testid={`${dataTestId}-label`}
      >
        {config.label}
      </div>
    </div>
  );
};

export default StatusBadge;
